import { ValueOf } from "type-fest";

export const WorkbenchDiffStatus = {
  ADDED: "added",
  MODIFIED: "modified",
  DELETED: "deleted",
  UNMODIFIED: "unmodified",
} as const;
export type WorkbenchDiffStatus = ValueOf<typeof WorkbenchDiffStatus>;
